/** @jsx jsx */
import { jsx } from '@emotion/core';
import escapeRegExp from 'lodash/escapeRegExp';
import { SafePureComponent } from '../../../utils/SafePureComponent';

const getTextParts = (regex, parts, matchCss) =>
  parts
    .filter(part => part)
    .map((part, i) =>
      regex.test(part) ? (
        <span css={matchCss} key={i}>
          {part}
        </span>
      ) : (
        <span key={i}>{part}</span>
      ),
    );

class HighlightedText extends SafePureComponent {
  safeRender() {
    const {
      text = '',
      highlight = '',
      matchCss = {},
      textCss = {},
    } = this.props;
    if (!highlight.trim()) {
      return <span css={textCss}>{text}</span>;
    }

    const regex = new RegExp(`(${escapeRegExp(highlight)})`, 'gi');
    const parts = text.split(regex);

    return <span css={textCss}>{getTextParts(regex, parts, matchCss)}</span>;
  }
}

HighlightedText.displayName = 'HighlightedText';

export default HighlightedText;
